import { Flex, Space, Typography } from 'antd'

const { Title, Text } = Typography

const Header = ({ step }) => {
    return (
        <Space
            direction="vertical"
            size={13}
            align="center"
            style={{ textAlign: 'center', maxWidth: '750px' }}
        >
            {
                {
                    planComparison: (
                        <>
                            <Title level={1} style={{ fontWeight: 'bold', margin: 0 }}>
                                Você pode perder os benefícios de sua assinatura
                            </Title>
                            <Text type="secondary" style={{ fontSize: '16px' }}>
                                Entendemos se quiser seguir com um plano grátis, mas considere as vantagens que perderá.
                            </Text>
                        </>
                    ),
                    reason: (
                        <>
                            <Title level={1} style={{ fontWeight: 'bold', margin: 0 }}>
                                Você está perdendo os benefícios de sua assinatura
                            </Title>
                            <Text type="secondary" style={{ fontSize: '16px' }}>
                                Ao cancelar seu plano Essencial, seus limites serão restaurados
                                para o plano Grátis. Seus dados continuarão seguros por 30 dias.
                            </Text>
                        </>
                    ),
                    password: (
                        <Title level={1} style={{ fontWeight: 'bold', margin: 0 }}>
                            Para cancelar sua assinatura, insira sua senha
                        </Title>
                    ),
                    confirmation: (
                        <Title level={1} style={{ fontWeight: 'bold', margin: 0 }}>
                            Sua conta agora é grátis
                        </Title>
                    )
                }[step]
            }
        </Space>
    )
}

export default Header
